export default function getAssetTypes(refObj) {
  let assetTypes = [];
  for (const assetType in refObj) {
    assetTypes.push(assetType);
  }
  return assetTypes;
}
